import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { UrlApi } from "../../../../services/apirest";
import {
  Button,
  Dialog,
  DialogContent,
  Box,
  Stack,
  IconButton,
  TextField,
  Autocomplete,
  Grid
} from "@mui/material";
import DialogContentText from "@mui/material/DialogContentText";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import PropaneIcon from "@mui/icons-material/Propane";
import DeleteIcon from "@mui/icons-material/Delete";

//Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

import { grey } from "@mui/material/colors";
import Title from "../../../Title";

function generate(element) {
  return [0, 1, 2].map((value) =>
    React.cloneElement(element, {
      key: value,
    })
  );
}

const Demo = styled("div")(({ theme }) => ({
  // backgroundColor: theme.palette.background.paper,
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


function DialogProPre(props) {
  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  const [datosFormulario, setDatosFormulario] = useState(props.datosformulario);
  const [dense, setDense] = React.useState(false);
  const [secondary, setSecondary] = React.useState(false);
  const [productosPredeterminadosCar, setProductosPredeterminadosCar] =
    useState();
  const [productos, setProductos] = useState();
  const [productoSeleccionado, setProductoSeleccionado] = useState("");

  const obtenerProductosPredeterminados = () => {
    fetch(
      UrlApi + "/envasado_producto_predeterminado/xdir/" + datosFormulario.id
    )
      .then((data) => data.json())
      .then((data) => setProductosPredeterminadosCar(data));
  };

  const obtenerProductos = () => {
    fetch(UrlApi + "/productos/envasados") //fetch con la urp de api q esta en services/apirest + la ruta
      .then((data) => data.json()) //mando los datos que recibo en json
      .then((data) => setProductos(data)); //seteo Sucursales
  };

  useEffect(() => {
    obtenerProductos();
    obtenerProductosPredeterminados();
  }, [datosFormulario]);

  const guardarRelacion = () => {
    fetch(UrlApi + "/envasado_producto_predeterminado", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id_direccion: datosFormulario.id,
        id_producto: productoSeleccionado.idproducto,
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El producto predeterminado se guardó exitosamente !");
          console.log("Guardado");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar el producto");
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const borraRelacion = async (id_predeterminado) => {
    fetch(UrlApi + "/envasado_producto_predeterminado/" + id_predeterminado, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (!res.err) {
        setOpenSnack(true);
        // PONGO EL UPDATE EN TRUE PARA QUE LA TABLA SE ACTUALICE CON CADA ACTUALIZACION EN LOS DATOS
        setColorMensaje("#D4EFDF");
        setMensaje("El producto predeterminado se eliminó");
        console.log("Guardado");
      } else {
        setOpenSnack(false);
        setColorMensaje("#F1948A");
        setMensaje("Error al eliminar el producto");
        console.log("Error");
      }
    });
  };

  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    obtenerProductosPredeterminados();
  };

  return (
    <div>
      <Dialog
        fullWidth
        open={props.open}
        onClose={() => props.setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ "& .MuiDialog-paper": { width: "50%", maxHeight: 500 } }}
      >
        <Title
          titulo={`Productos Predeterminados`}
          handleClose={() => {
            props.setOpen(false);
          }}
        />
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <form autoComplete="off">
              <Grid container>
                <Grid item xs={12} py={1} mb={1}>
                  <Autocomplete
                    disabled={!productos}
                    required
                    disableClearable
                    id="producto"
                    size="small"
                    noOptionsText={"Producto INEXISTENTE"}
                    options={productos}
                    autoHighlight
                    getOptionLabel={(producto) =>
                      producto.codigoproducto + "-" + producto.nombre
                    }
                    onChange={(event, value) => {
                      setProductoSeleccionado(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.codigoproducto} - {option.nombre}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        placeholder="Tipee para buscar..."
                        {...params}
                        focused
                        label="Producto"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid>
                <Demo>
                  <List
                    dense={dense}
                    style={{ width: "140%", marginBottom: 5 }}
                  >
                    {productosPredeterminadosCar
                      ? productosPredeterminadosCar.map((producto, index) => (
                          <ListItem
                            key={index}
                            style={{ backgroundColor: "#F4F6F6" }}
                          >
                            <PropaneIcon />
                            <ListItemText
                              style={{ marginLeft: 30, marginRight: -60 }}
                              primary={
                                (
                                  <b>
                                    {producto.nombre}-{producto.codigoproducto}
                                  </b>
                                ) || "No disponible"
                              }
                            />
                            <IconButton
                              onClick={() => borraRelacion(producto.id)}
                              color="error"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </ListItem>
                        ))
                      : null}
                  </List>
                </Demo>
              </Grid>
              <Stack direction="row">
                <Grid container size={"grow"} direction={{ xs: "column", sm: "row" }}>
                  <Grid item xs={9}>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => props.setOpen(false)}
                    >
                      Volver
                    </Button>
                  </Grid>
                  <Grid item xs={3}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="success"
                      onClick={guardarRelacion}
                    >
                      Guardar
                    </Button>
                  </Grid>
                </Grid>
              </Stack>
            </form>
          </DialogContentText>
        </DialogContent>
        {/* </form> */}
        <Stack spacing={2} sx={{ width: "100%" }}>
          <Snackbar
            open={openSnack}
            autoHideDuration={1500}
            onClose={handleCloseSnack}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="success"
              sx={{ width: "100%" }}
              style={{ backgroundColor: colormensaje, color: "black" }}
            >
              {mensaje}
            </Alert>
          </Snackbar>
        </Stack>
      </Dialog>
    </div>
  );
}

export default DialogProPre;
